<template>
	<div :class="fab ? 'pa-0' : 'pa-2'">

		<v-btn
			v-if="fab"
				fab
				dark
				fixed
				top
				right
				:color="btnColor"
				@click.stop="drawer = !drawer"
				:style="{
					top: iconTop,
					right: '16px',
					width: '40px',
					height: '40px',
					minWidth: '40px'
				}"
			>
			<v-icon small>mdi-magnify</v-icon>
		</v-btn>

		<v-btn
			v-else
			color="white"
			icon
			:style="{'background-color': btnColor}"
			@click.stop="drawer = !drawer"
			:small="small"
		>
			<v-icon>mdi-magnify</v-icon>
		</v-btn>

		<v-navigation-drawer
			:class="is_mobile ? 'navigation-drawer--mobile' : 'navigation-drawer--desktop'"
			v-if="drawer" v-model="drawer" app clipped temporary right>

			<template>
				<v-list dense nav>
					<v-list-item>
						<v-list-item-content>
						<v-list-item-title class="title --text title-color">
							Filtros
						</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-divider></v-divider>
					<div class="search-btn" style="margin-top: 0px">
						<v-row>
						<v-col cols="6" class="pr-0">
						<v-btn color="primary" rounded v-on:click="searchFunc">
						Buscar
						</v-btn>
						</v-col>
						<v-col cols="6" class="pr-0">
						<v-btn v-on:click="cleanFunc"><v-icon v-once>
						mdi-eraser
						</v-icon></v-btn>
						</v-col>
						</v-row>
					</div>
					<div class="filter">
						<slot name="inputs"></slot>
					</div>
				</v-list>
			</template>

		</v-navigation-drawer>

	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        filters: {
					type: String,
					required: false,
					default: ''
        },
        searchFunc: {
					type: Function,
					required: false,
					default: function () {
						return '';
					},
        },
        cleanFunc: {
					type: Function,
					required: false,
					default: function () {
						return '';
					},
        },
				small: {
					type: Boolean,
					required: false,
					default: false,
				},
				fab: {
					type: Boolean,
					required: false,
					default: false,
				},
				iconTop: {
					type: String,
					required: false,
    			default: '130px'
				}
    },
	computed: {
		btnColor() {
			let color = "var(--v-primary-base)"; // primary
            if (this.filters.length > 0) {
                color = "var(--v-secondary-base)"; // secondary
            }
            return color;
		}	,
		...mapGetters({
        is_mobile: 'is_mobile',
    }),
	},
    data() {
        return {
            drawer: false,
        };
    },
};
</script>

<style lang="scss" scoped>
	.filter {
		padding-left: 10px;
		padding-right: 10px;
	}
	.search-btn {
		text-align: center;
	}
	.title-color {
		color:var(--v-primary-base);
	}
</style>

<style>
	.navigation-drawer--desktop {
    width: 18% !important;
	}
	.navigation-drawer--mobile {
    height: 100vh !important;
    width: 80% !important;
    overflow-y: auto !important;
	}
</style>